export const STATUS_MAP = {
  pending_approval: 'Pending approval',
  rejected: 'Rejected',
  stopped: 'Stopped',
  active: 'Active',
  ready: 'Ready',
  review_audio: 'Awaiting review',
  complete: 'Complete',
  processing: 'Processing',
};

export const FILTER_TO_STATUS = {
  'All ads': '',
  Active: 'active',
  Complete: 'complete',
  Processing: 'processing',
  'Pending approval': 'pending_approval',
  Ready: 'ready',
  Rejected: 'rejected',
  'Awaiting review': 'review_audio',
  Stopped: 'stopped',
};

export const STATUS_DESCRIPTION_MAP = {
  pending_approval: 'Your ad is being reviewed for approval by the Spotify ads team.',
  rejected: 'Your ad has been rejected for reasons detailed in an email sent to you. If you would like to run a rejected ad, please rebuild another compliant ad. Alternatively, if you rejected a voiceover, the ad will also display as a rejected ad.',
  stopped: 'You stopped the ad before its scheduled end date.',
  active: 'Your ad is live. Our ad server will deliver your ad to your available selected audience.',
  ready: 'Your ad has been approved and will go live according to your selected start date.',
  review_audio: 'Your requested voiceover is ready for your review. In the “Review” state, you can approve the voiceover or request revisions. If you uploaded your own audio voiceover, your ad will not pass through this state.',
  complete: 'Your ad is no longer delivering. Final metrics may not be updated until the next day.',
  processing: 'Your audio ad is being mixed. If you requested a voiceover, it will move into "Review" after it is done processing. If you uploaded your own audio voiceover, it will move into "Pending Approval" after it is done processing.',
};



// WEBPACK FOOTER //
// ./src/mappers/status.js